<template>
  <div>
    <div class="row pb-5">
      <div class="col-12 col-lg-8 d-flex flex-column">
        <div><div><campaigns-panel /></div></div>
        <div class="pb-4"><top-stories-panel /></div>
        <div class="pb-4 d-flex flex-grow-1 w-100"><news-by-interests /></div>
        <!-- <div class="pb-4"><resources-panel ref="resourcesPanel" /></div> -->
      </div>
      <div class="col-12 col-lg-4 pl-lg-2">
        <div class="pb-4"><right-panel /></div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import { mapGetters } from "vuex";
import * as CONSTANTS from "@/store/constants";
import OneMobileModal  from "./modals/OneMobileModal.vue";
import CampaignsPanel from "./campaigns/CampaignsPanel";
import TopStoriesPanel from "./news/TopStoriesPanel";
import RightPanel from "./RightPanel";
import ResourcesPanel from "./resources/ResourcesPanel";
import NewsByInterests from "./newsByInterests/NewsByInterests";
import LocalStorageMixin from "@/mixins/LocalStorageMixin";
import { createStandardModal } from "@/utils/modalHelper";

export default {
  name: "homebase-home",
  mixins: [LocalStorageMixin],
  components: {
    TopStoriesPanel,
    CampaignsPanel,
    RightPanel,
    ResourcesPanel,
    NewsByInterests,
    OneMobileModal
  },
  data() {
    return {
      modalInstance: null
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    this.checkShowOneMobileModal();
  },
  methods: {
    async checkShowOneMobileModal() {
      // Retrieve active campaign and validate whether to display it or not
      const campaign = await api.getActivePopupVideoCampaign();
      if(campaign.value.length > 0) {
        const campaignData = campaign.value[0].fields;
        const userHasVisited = this.hasFlag(CONSTANTS.VIDEO_POPUP_CAMPAIGN_FIRST_TIME_VISIT_KEY, campaignData.LocalStorageKey);
        if (!userHasVisited) {
          try {
            const isMember = await this.isUserMemberOfAudience(campaignData._ModernAudienceAadObjectIds);
            if(isMember) {
              this.showOneMobileModal(campaignData);
            }
          } catch (e) {
            console.log(e);
          }
        }
      }
    },
    async isUserMemberOfAudience(audience) {
      if(audience.length > 0) {
        const audienceId = audience[0].LookupValue.replace(/[\])}[{(]/g, '');
        let res = await api.filterUserGroups(audienceId);
        return res.data.value.length > 0;
      }
      else {
        return true;
      }
    },
    showOneMobileModal(campaignData) {
      // Create modal instance using vue-final-modal v4 API
      this.modalInstance = createStandardModal(OneMobileModal, {
        props: {
          campaignData
        },
        maxWidth: '880px'
      });

      // Open the modal
      this.modalInstance.open();
    }
  },
  watch: {
    // impersonation
    "user.userName": function () {
      this.$refs.resourcesPanel.getResources();
    },
  },

  beforeUnmount() {
    // Cleanup modal instance when component is destroyed
    if (this.modalInstance) {
      this.modalInstance.destroy();
    }
  }

};
</script>

<style scoped>
/* force adjust column sizes */
@media (min-width: 992px) {
  .col-lg-4 {
    -ms-flex: 0 29%;
    -webkit-box-flex: 0;
    flex: 0 0 29%;
    max-width: 29%;
  }
  .col-lg-8 {
    -ms-flex: 0 71%;
    -webkit-box-flex: 0;
    flex: 0 0 71%;
    max-width: 71%;
  }
}
</style>
